module.exports = __webpack_public_path__ + "img/404_1440.b24680e4.png";